<template>
  <base-form :loading="loading"
             :title="$t('settings.ecommerce.title')"
             @submit="submitForm">
    <fg-input :label="$t('settings.ecommerce.currency')"
              :error="getError($t('settings.ecommerce.currency'))">
      <el-select class="select-default all-country-select"
                 :name="$t('settings.ecommerce.currency')"
                 filterable
                 clearable
                 v-validate="modelValidations.app_currency"
                 v-model="model.app_currency">
        <el-option v-for="currency in currencies"
                   class="select-default"
                   :key="currency.code"
                   :label="currency.name_plural"
                   :value="currency.code">
        </el-option>
      </el-select>
    </fg-input>
    <fg-input :placeholder="$t('settings.ecommerce.price.placeholder')"
              :error="getError($t('settings.ecommerce.price.name'))"
              v-validate="modelValidations.app_credit_price"
              :name="$t('settings.ecommerce.price.name')"
              :label="$t('settings.ecommerce.price.name')"
              type="number"
              v-model="model.app_credit_price">
    </fg-input>
    <fg-input :label="$t('settings.ecommerce.primary_payment_type')">
      <payment-type-select v-model="primary_payment"></payment-type-select>
    </fg-input>
    <fg-input :placeholder="$t('settings.ecommerce.job_line')"
              :error="getError($t('settings.ecommerce.job_line'))"
              v-validate="modelValidations.app_job_line"
              :name="$t('settings.ecommerce.job_line')"
              :label="$t('settings.ecommerce.job_line')"
              v-model="model.app_job_line">
      <small slot="infoBlock">
        {{$t('settings.ecommerce.job_line.info')}}
      </small>
    </fg-input>
    <dl class="rounded overflow-hidden mt-6 mb-4">
      <div class="list-row bg-gray-50">
        <dt class="list-row-dt">
          {{$t(`settings.ecommerce.job.validate_clients`)}}
        </dt>
        <dd class="list-row-dd">
          <base-switch v-model="model.app_auto_validate_clients">
          </base-switch>
        </dd>
      </div>
      <div class="list-row bg-white">
        <dt class="list-row-dt">
          {{$t(`settings.ecommerce.validate_orders`)}}
        </dt>
        <dd class="list-row-dd">
          <base-switch v-model="model.app_auto_validate_orders">
          </base-switch>
        </dd>
      </div>
      <div class="list-row bg-gray-50">
        <dt class="list-row-dt">
          {{$t(`settings.ecommerce.invoice_enabled`)}}
        </dt>
        <dd class="list-row-dd">
          <base-switch v-model="model.app_invoice_enabled">
          </base-switch>
        </dd>
      </div>
    </dl>
  </base-form>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import settingsMixin from './settingsMixin'
  import currencies from 'src/services/currencies'
  import PaymentTypeSelect from 'src/components/Autocomplete/SimplePaymentTypeSelect'

  export default {
    name: 'settings-ecommerce',
    mixins: [settingsMixin],
    components: {
      PaymentTypeSelect,
      [Select.name]: Select,
      [Option.name]: Option,
    },

    data () {
      return {
        loading: false,
        model: {
          app_currency: '',
          app_credit_price: '',
          app_auto_validate_clients: '',
          app_auto_validate_orders: '',
          app_invoice_enabled: '',
          app_primary_payment_id: '',
          app_job_line: '',
        },
        currencies
      }
    },
    computed: {
      modelValidations () {
        return {
          app_credit_price: {
            required: true,
            min_value: 0,
            numeric: true
          },
          app_currency: {
            required: true
          },
          app_job_line: {
            required: true
          }
        }
      },
      primary_payment: {
        get () {
          if (!this.model.app_primary_payment_id) {
            return ''
          }
          return parseInt(this.model.app_primary_payment_id)
        },
        set (value) {
          this.model.app_primary_payment_id = parseInt(value)
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async submitForm () {
        let res = await this.$validator.validateAll()
        if (res) {
          try {
            this.loading = true
            await this.updateSettings(this.model)
            this.$notify({type: 'success', message: this.$t('settings.general.success')})
          } catch (e) {
            this.$notify({type: 'danger', message: this.$t('settings.general.success')})
          } finally {
            this.loading = false
          }
        }

      }
    }
  }
</script>
<style>
</style>
